import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import SwipeableViews from "react-swipeable-views"
import AppBar from "@material-ui/core/AppBar"
import Tabs from "@material-ui/core/Tabs"
import Tab from "@material-ui/core/Tab"
import Typography from "@material-ui/core/Typography"
import styled from "styled-components"
import { replaceWithSymbol } from "../../util/cutString"

import MyBidBox from "./MyBidBox"
import PrimaryButton from "../../components/buttons/PrimaryButton"

import config from "../../Config"
import i18n from "../../i18n"

const NoBidFoundContainer = styled.div`
  background-color: #1c1d23;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const ImageWrapper = styled.div`
  height: 25%;
  width: 100%;
  margin: 10px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const TextArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #fff;
`

const PlaceBidButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 280px;
  height: 56px;
  padding: 19px 60px 18px;
  border-radius: 30px;
  background-color: #fb0e56;
  box-sizing: border-box;
`

const Wrapper = styled.div`
  width: 100%;
  height: calc(100vh - 144px);
`

function TabContainer({ children, dir }) {
  return (
    <Typography
      component='div'
      dir={dir}
      style={{
        padding: 10,
        alignSelf: "center",
        margin: 0,
        backgroundColor: "#1c1d23",
        // minHeight: "calc(100vh - 114px)",
        // boxSizing: "border-box",
        // display: "flex",
        // justifyContent: "center",
        // alignItems: "center",
      }}
    >
      {children}
    </Typography>
  )
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
}

const styles = (theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: "100%",
  },

  tabsIndicator: {
    backgroundColor: "#fb0e56",
    height: "3px",
    width: "100%",
  },
  tabRoot: {
    textTransform: "initial",
    backgroundColor: "#000",
    fontWeight: theme.typography.fontWeightRegular,
    color: "#fff",
    fontFamily: "montserratRegular",
    fontSize: "16px",
    letterSpacing: "1px",
    "&:hover": {
      color: "#fff",
      opacity: 1,
    },
    "&$tabSelected": {
      color: "#fff",
      opacity: 1,
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&:focus": {
      color: "#fff",
    },
  },
  tabSelected: {},
})

class FullWidthTabs extends React.Component {
  state = {
    value: 0,
  }

  handleChange = (event, value) => {
    this.setState({ value })
  }

  handleChangeIndex = (index) => {
    this.setState({ value: index })
  }

  render() {
    const { classes, theme, myBids, expiredBids, bidClick } = this.props

    console.log("myBidss", myBids)
    const nonActiveBids = myBids.filter((fl) => fl.isActiveOffer === false)
    console.log("nonActiveBids", nonActiveBids)

    return (
      <div className={classes.root}>
        <AppBar position='static' color='default'>
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor='primary'
            textColor='primary'
            fullWidth
            classes={{
              root: classes.tabsRoot,
              indicator: classes.tabsIndicator,
            }}
          >
            <Tab
              label={i18n.t("LiveBids")}
              classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
            />
            <Tab
              label={i18n.t("ExpiredBids")}
              classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
            />
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={this.state.value}
          onChangeIndex={this.handleChangeIndex}
        >
          <TabContainer dir={theme.direction}>
            <div className='container_body'>
              <div style={{ padding: "10px" }}>
                <Wrapper>
                  {myBids && myBids.length > 0 ? (
                    myBids.map((bid) => {
                      console.log("myBids", myBids)
                      console.log("bid", bid)
                      if (bid.isActiveOffer) {
                        return (
                          <MyBidBox
                            {...bid}
                            // onClick={() =>
                            //   this.props.history.push(
                            //     `/play/my-bids/${replaceWithSymbol(
                            //       bid.offerTitle
                            //     )}/${bid.offerId}`
                            //   )
                            // }
                            onClick={() =>
                              bidClick(
                                `/play/my-bids/${replaceWithSymbol(
                                  bid.offerTitle
                                )}/${bid.offerId}`
                              )
                            }
                          />
                        )
                      }
                    })
                  ) : (
                    <NoBidFoundContainer>
                      <ImageWrapper>
                        <img
                          style={{ width: "40%" }}
                          src={`${
                            config.MRBIDNWIN_S3_IMAGE_URL
                          }/ic-facebook-login-bidding.svg`}
                          alt='Logo'
                        />
                      </ImageWrapper>
                      <TextArea>
                        <b className='montserratSemiBold'>
                          {i18n.t("NoBidsPlaced")}
                        </b>
                        <div
                          className='montserratRegular'
                          style={{ margin: "10px 0px" }}
                        >
                          {i18n.t("FirstBidPlaced")}
                        </div>
                      </TextArea>
                      <PlaceBidButton>
                        <PrimaryButton
                          label='Place Bid'
                          variant='contained'
                          style={{
                            width: "70%",
                            height: 54,
                            backgroundColor: "#fb0e56",
                          }}
                          onClick={this.placeBid}
                        />
                      </PlaceBidButton>
                    </NoBidFoundContainer>
                  )}
                </Wrapper>
              </div>
            </div>
          </TabContainer>
          <TabContainer dir={theme.direction}>
            <div className='container_body'>
              <Wrapper>
                {nonActiveBids && nonActiveBids.length > 0 ? (
                  nonActiveBids.map((bid) => {
                    console.log("heyBd", bid)
                    if (!bid.isActiveOffer) {
                      return (
                        <MyBidBox
                          {...bid}
                          expiredBid='true'
                          onClick={() =>
                            bidClick(
                              `/play/my-bids/expired/${replaceWithSymbol(
                                bid.offerTitle
                              )}/${bid.offerId}`
                            )
                          }
                        />
                      )
                    }
                  })
                ) : (
                  <NoBidFoundContainer>
                    <ImageWrapper>
                      <img
                        style={{ width: "40%" }}
                        src={`${
                          config.MRBIDNWIN_S3_IMAGE_URL
                        }/ic-facebook-login-bidding.svg`}
                        alt='Logo'
                      />
                    </ImageWrapper>
                    <TextArea>
                      <b className='montserratSemiBold'>
                        {i18n.t("NoBidsPlaced")}
                      </b>
                      <div
                        className='montserratRegular'
                        style={{ margin: "10px 0px" }}
                      >
                        {i18n.t("FirstBidPlaced")}
                      </div>
                    </TextArea>
                    <PlaceBidButton>
                      <PrimaryButton
                        label='Place Bid'
                        variant='contained'
                        style={{
                          width: "70%",
                          height: 54,
                          backgroundColor: "#fb0e56",
                        }}
                        onClick={this.placeBid}
                      />
                    </PlaceBidButton>
                  </NoBidFoundContainer>
                )}
              </Wrapper>
            </div>
          </TabContainer>
        </SwipeableViews>
      </div>
    )
  }
}

FullWidthTabs.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}

export default withStyles(styles, { withTheme: true })(FullWidthTabs)



// WEBPACK FOOTER //
// ./src/components/bidTab/bidTab.js